import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'riskLevelClass',
  standalone: true,
})
export class RiskLevelClassPipe implements PipeTransform {
  transform(riskLevel: string | null | undefined): string {
    switch (riskLevel) {
      case 'inaceptable':
        return 'text-alert-dark';

      case 'alto':
        return 'text-alert-base';

      case 'limitado':
        return 'text-info-base';

      case 'minimo':
        return 'text-success-base';

      default:
        return '';
    }
  }
}
